/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portalnav_PostsInputs */

const en_portalnav_posts = /** @type {(inputs: Portalnav_PostsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posts`)
};

/** @type {(inputs: Portalnav_PostsInputs) => LocalizedString} */
const ar_portalnav_posts = en_portalnav_posts;

/** @type {(inputs: Portalnav_PostsInputs) => LocalizedString} */
const he_portalnav_posts = en_portalnav_posts;

/** @type {(inputs: Portalnav_PostsInputs) => LocalizedString} */
const ur_portalnav_posts = en_portalnav_posts;

/** @type {(inputs: Portalnav_PostsInputs) => LocalizedString} */
const es_portalnav_posts = en_portalnav_posts;

/** @type {(inputs: Portalnav_PostsInputs) => LocalizedString} */
const fr_portalnav_posts = en_portalnav_posts;

/** @type {(inputs: Portalnav_PostsInputs) => LocalizedString} */
const de_portalnav_posts = en_portalnav_posts;

/** @type {(inputs: Portalnav_PostsInputs) => LocalizedString} */
const pt_portalnav_posts = en_portalnav_posts;

/** @type {(inputs: Portalnav_PostsInputs) => LocalizedString} */
const hi_portalnav_posts = en_portalnav_posts;

/** @type {(inputs: Portalnav_PostsInputs) => LocalizedString} */
const bn_portalnav_posts = en_portalnav_posts;

/**
* | output |
* | --- |
* | "Posts" |
*
* @param {Portalnav_PostsInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const portalnav_posts = /** @type {((inputs?: Portalnav_PostsInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portalnav_PostsInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_portalnav_posts(inputs)
	if (locale === "he") return he_portalnav_posts(inputs)
	if (locale === "ur") return ur_portalnav_posts(inputs)
	if (locale === "es") return es_portalnav_posts(inputs)
	if (locale === "fr") return fr_portalnav_posts(inputs)
	if (locale === "de") return de_portalnav_posts(inputs)
	if (locale === "pt") return pt_portalnav_posts(inputs)
	if (locale === "hi") return hi_portalnav_posts(inputs)
	if (locale === "bn") return bn_portalnav_posts(inputs)
	return /** @type {LocalizedString} */ ("Posts")
});